import { Reference } from '@sydle/ui-api';
import type { FetchResponse, Interceptor } from '@sydle/ui-api';
import { extractInfosByURL } from '../utils/url';
import { normalizeMetadata } from './form-metadata-normalizer';
import type { ClassesMetadatas, FieldsMetadatas, Metadata } from '../../components';
import { OneApi } from '../../components/one-api/one-api';
import { getState } from '../../store/store';
import { getSupportedLanguages } from '../../store/env/env.selectors';

type FormApiResponse = {
  object: any;
  extendedMetadata?: Metadata;
  metadatas?: ClassesMetadatas;
  fields?: FieldsMetadatas;
  filteredFieldPath?: string;
};
export class FormInterceptor implements Interceptor {
  interceptorResponse = async (response: FetchResponse<FormApiResponse>): Promise<any> => {
    const { methodIdentifier } = extractInfosByURL(response.meta.requestParams.url, true);

    if (methodIdentifier?.includes('getForm') || methodIdentifier?.includes('patchForm')) {
      const formResponse = response.data;
      if (formResponse?.extendedMetadata) {
        const { fields, metadatas } = normalizeMetadata(
          {
            extendedMetadata: formResponse.extendedMetadata,
            reference: new Reference(formResponse.object._id, formResponse.object._class._id),
            filteredFieldPath: formResponse.filteredFieldPath,
          },
          OneApi.userAPI.getCurrentLanguage() as any,
          getSupportedLanguages(getState()),
        );

        response.data['metadatas'] = metadatas;
        response.data['fields'] = fields;
      }
    }
    return response;
  };
}
